<template>

  <div>

    <div class="pharmacySelector box is-clearfix" v-if="showPharmacyFilter && userRole=='Administrator'">

      <template v-if="!pharmaciesLoaded">
          <loading-indicator-pulse class="small" style="margin: 20px 0;"></loading-indicator-pulse>
      </template>

      <template v-else>

        <div class="pharmacySelectorLabel">Apotheke auswählen</div>
        <form-input
            inputType="select"
            :showLabel="false"
            label="PIM-SELECT_SORTIMENT"
            v-model="pharmacySelectedWrapper"
            selectFieldName="_name"
            :selectIsSearchable="true"
            :selectAllowEmpty="true"
            :selectOptions="pharmacies"
            :showLabelInOptions="false">
        </form-input>

      </template>

    </div>

    <v-server-table ref="pimTable" name="pimTable" :class="['pimTable', { 'noFirstColumn': !showPagination }]" :columns="tblColumns" :options="table.tblOptions">

      <template slot="h__select" v-if="(!singleSelectOnly && allowSelection) || (!singleSelectOnly && userRole == 'Administrator')">
        <p-check name="check" color="primary" class="p-default p-curve p-smooth" v-model="allMarked" @click.native="toggleMarkAll()"></p-check>
      </template>

      <!-- before table: FILTER OPTIONS -->
      <template slot="beforeTable">

          <div class="box" style="padding: 15px;">

              <fieldset :class="['filterBox', { active: showFilterBox }]" v-if="showFilters">

                  <legend @click="showFilterBox=!showFilterBox">
                      Filter
                      <template v-if="!showFilterBox">+</template><template v-else>-</template>
                  </legend>

                  <!-- <transition name="fade" appear> -->

                      <div class="filterWrapper" v-if="showFilterBox">
                          <filter-element v-for="filter in filtersSelected" :filter="filter" :key="filter.queryName"></filter-element>
                      </div>

                  <!-- </transition> -->

              </fieldset>

              <div class="columns is-marginless filters">

                  <!-- SUCHE -->
                  <div class="column">

                      <div class="control has-icon search" style="min-width:150px;">
                          <input class="input" type="text" v-model.trim="filters.filterSearch.value" placeholder="Suchbegriff" @keyup.enter="filter()">
                          <i class="fa fa-search" aria-hidden="true"></i>
                      </div>
                  </div>

                  <div class="column is-narrow">

                      <span class="button is-success filter" @click="filter()">
                          anwenden
                          <span class="icon is-small success" style="margin: 0 !important;">
                              <i class="icon-ak-filter"></i>
                          </span>
                      </span>

                      <span :class="[isFilterActive ? 'is-blue' : 'is-disabled', 'button reset-filter']"  @click="resetFilters()" style="margin: 0 0 0 5px;">
                          <span class="icon is-small">
                              <i class="icon-ak-reset"></i>
                          </span>
                      </span>

                  </div>

              </div>

          </div>

      </template>

      <template v-if="isLoadingTableData" slot="afterBody">

        <div class="overlay-loader"></div>
        <loading-indicator></loading-indicator>

      </template>

      <!-- checkbox -->
      <template slot="select" slot-scope="props" v-if="allowSelection || userRole == 'Administrator' || props.row.site_id != null">

        <div class="checkboxWrapper">
          <p-check
            name="check"
            color="primary"
            :value="props.row"
            v-model="markedRows"
            class="p-default p-curve p-smooth"
            @change="val => { if (singleSelectOnly) markedRows = val ? [props.row] : [] }"
          ></p-check>
        </div>

      </template>

      <!-- image -->
      <template slot="image" slot-scope="props">
        <div class="imgWrapper lazy-img-fadein" v-lazy:background-image="props.row.image" :key="props.row.id">
          <div :class="['status', props.row.stockType]" :title="productStatus[props.row.stockType]"></div>
        </div>
      </template>

      <!-- price -->
      <template slot="price" slot-scope="props">
        {{ formatPoint2Comma(props.row.price) }}
      </template>

      <!-- name -->
      <template slot="name" slot-scope="props">

        <template v-if="allowEditName && (pharmacySelected == null || (pharmacySelected != null && pharmacySelected.id == props.row.site_id))">
            <input type="text" class="input is-normal inputName" :title="props.row.name" :value="props.row.name" @click.prevent.stop="" @change="changeName(props.row.id, $event)" />
        </template>
        <template v-else>
            {{ props.row.name }}
        </template>

      </template>

      <!-- variable product -->
      <template slot="group_id" slot-scope="props">

        <template v-if="props.row.group_id != null">
          <span class="icon is-small">
            <i class="icon-ak-variables-produkt" title="variables Produkt"></i>
          </span>
        </template>

        <template v-else>
          <span class="icon is-small">
            <i class="icon-ak-einzelprodukt" title="einfaches Produkt"></i>
          </span>
        </template>

      </template>

      <!-- delete -->
      <template slot="actions" slot-scope="props">

        <template v-if="allowDelete && (pharmacySelected == null || (pharmacySelected != null && pharmacySelected.id == props.row.site_id))">
          <pop-confirm class="button is-small" content="Sind Sie sicher, dass Sie dieses Produkt löschen und somit auch aus dem Webshop entfernen wollen?" icon="question-circle-o" :on-ok="function() { deleteProduct(props.row) }" cancel-text="nein">
              <span class="icon is-small" title="Produkt löschen">
                  <i class="icon-ak-entfernen"></i>
              </span>
          </pop-confirm>
        </template>

      </template>

    </v-server-table>

  </div>

</template>




<script>
import Vue from 'vue';
import { ServerTable, Event} from 'vue-tables-2';
Vue.use(ServerTable, {}, false, 'bulma');

import filterElement from './incl-filterElement.vue'
import PrettyCheckbox from 'pretty-checkbox-vue';
Vue.use(PrettyCheckbox);

export default {

  name: 'pimProducts',

	components: {
    filterElement,
	},

  props: {

    showFilters: {
      type: [Array, Boolean],
      required: false,
      default: true
    },
    showPharmacyFilter: {
        type: Boolean,
        default: true
    },
    showPagination: {
        type: Boolean,
        default: true,
    },
    preselectedProducts: {
        type: Array,
        required: false,
        default: () => []
    },
    allowSelection: {
        type: Boolean,
        default: false,
    },
    allowEditProduct: {
        type: Boolean,
        default: true
    },
    allowEditName: {
        type: Boolean,
        default: true,
    },
    allowDelete: {
        type: Boolean,
        default: true
    },
    singleSelectOnly: {
        type: Boolean,
        default: false
    }

  },

	data() {

    var self = this;

		return {

      isLoadingTableData: false,
      showFilterBox: true,

      allMarked: false,
      markedRows: [],

      placeholder: "keine Änderung",
      batchObj: {},

      categories: null,
      uploadedFiles: [],

      uploadProcedere: 0,
      multiUploadReplaceFiles: false,

      pharmacies: [],
      pharmaciesLoaded: false,

      files: {
        accepted: [],
        rejected: [],
      },

      modal: {
        isSaving: false,
        isLoading: false,
        title: '',
        type: null,
        class: '',
      },

      refreshIntervalId: null,
      progressStatus: null,
      sortimentUploadType: 'default',

      froalaConfig: {
        key: '',
        linkAlwaysBlank: true,
        toolbarButtons: ['bold', 'italic', 'underline', '|', 'insertLink'],
        wordPasteModal: false,
        pastePlain: true,
        heightMin: 300,
        heightMax: 1024,
        quickInsertTags: null,
        quickInsertButtons: false,
        language: 'de',
        charCounterCount: false,
      },

      productStatus: {
        'available': 'verfügbar',
        'currently-not-availabe': 'momentan nicht verfügbar',
        'not-available': 'nicht verfügbar',
        'local': 'auf Lager'
      },

      filters: {

          filterSearch: {
              type: 'search',
              queryName: 'query',
              isActive: false,
              value: null,
              show: false,
          },

          filterImage: {
              type: 'default',
              queryName: 'hasImage',
              isActive: false,
              options: [
                  { name: 'ohne Bild', selected: false, id: 0 },
                  { name: 'mit Bild', selected: false, id: 1 }
              ]
          },

          filterVariableProduct: {
              type: 'default',
              queryName: 'isVariable',
              isActive: false,
              options: [
                  { name: 'einfaches Produkt', selected: false, id: 0 },
                  { name: 'variables Produkt', selected: false, id: 1 }
              ]
          },

          filterIsDrug: {
              type: 'default',
              queryName: 'isDrug',
              isActive: false,
              options: [
                  { name: 'kein Arzneimittel', selected: false, id: 0 },
                  { name: 'Arzneimittel', selected: false, id: 1 },
              ]
          },

          filterPackageLeaflet: {
              type: 'default',
              queryName: 'hasPackageLeaflet',
              isActive: false,
              options: [
                  { name: 'ohne Packungsbeilage', selected: false, id: 0 },
                  { name: 'mit Packungsbeilage', selected: false, id: 1 }
              ]
          },

          filterIncomplete: {
              type: 'default',
              queryName: 'incomplete',
              isActive: false,
              options: [
                  { name: 'Apopoint-Daten fehlen', selected: false, id: 1 }
              ]
          },

          filterMultiple: {
              type: 'default',
              queryName: 'multiple',
              isActive: false,
              options: [
                  { queryName: 'isApoPoint', name: 'Webshop', selected: false, id: 1 },
                  { queryName: 'isApokat', name: 'Apothekenkatalog', selected: false, id: 1 },
                  { queryName: 'isEquipmentCatalog', name: 'Gerätekatalog', selected: false, id: 1 },
                  { queryName: 'nonApopointAssortment', name: 'Nicht Apopoint', selected: false, id: 1 },
              ]
          },

          /*
          filterSite: {
              type: 'default',
              queryName: 'site',
              isActive: false,
              options: [
                  { name: 'Basis-Sortiment', selected: false, id: 0 },
                  { name: 'Eigensortiment', selected: false, id: 'any' }
              ]
          },
          */

          filterCategory: {
              type: 'category',
              queryName: 'category',
              isActive: false,
              api: 'pimCategory/tree',
              options: []
          },

          filterBrand: {
              type: 'brand',
              queryName: 'brand',
              isActive: false,
              api: 'pimBrand?orderBy=name&filters[name]=!',
              options: []
          },

          filterDateCreated: {
              type: 'date',
              queryName: 'created',
              isActive: false,
              label: 'created',
              options: {
                  date1: null,
                  date2: null
              }
          },

          filterDateUpdated: {
              type: 'date',
              queryName: 'updated',
              isActive: false,
              label: 'updated',
              options: {
                  date1: null,
                  date2: null
              }
          },

          filterUser: {
              type: 'dropdown',
              selectFieldName: 'name',
              queryName: 'editedBy',
              isActive: false,
              label: 'user',
              // api: 'user?include=user.username',
              api: 'pim/users',
              options: []
          },

          filterHasDescription: {
              type: 'default',
              queryName: 'hasDescription',
              isActive: false,
              options: [
                  { name: 'ohne Beschreibung', selected: false, id: 0 },
                  { name: 'mit Beschreibung', selected: false, id: 1 }
              ]
          },

          filterStockType: {
              type: 'default',
              queryName: 'stockType',
              isActive: false,
              options: [
                  { name: 'verfügbar', selected: false, id: 'available' },
                  { name: 'momentan nicht verfügbar', selected: false, id: 'currently-not-available' },
                  { name: 'nicht verfügbar', selected: false, id: 'not-available' },
                  { name: 'ohne Status', selected: false, id: 'none' },
                  { name: 'außer Verkehr', selected: false, id: 'discontinued' },
              ]
          },

          filterIncompleteDrugs: {
              type: 'default',
              queryName: 'incompleteDrugs',
              isActive: false,
              options: [
                  { name: 'Arzneimittelinformation unvollständig', selected: false, id: 1 }
              ]
          },

          filterNonApopointAssortment: {
              type: 'default',
              queryName: 'includeNonApopointAssortment',
              isActive: false,
              options: [
                  { name: 'inkl. Non-Apopoint Sortiment', selected: false, id: 1 }
              ]
          },

          
          filterSanova: {
            type: 'default',
            queryName: 'sanovaDownloadPlatform',
            isActive: false,
            options: [
                { name: 'Sanova Download-Platform', selected: false, id: 1 },
            ]
          },

          filterNewProducts: {
            type: 'default',
            queryName: 'newProducts',
            isActive: false,
            options: [
                { name: 'Neue Produkte', selected: false, id: 1 },
            ]
          },

      },

      showModal: false,
      showModalConfirmation: false,

      table: {

        // tblColumns: ['select', 'image', 'extRef', 'name', 'categoryPath', 'price', 'packagingSize', 'manufacturerName', 'group_id', 'delete'],
        tblOptions: {

          requestFunction(data) {

            if(data.query != "" && data.query != null) {

              let query = JSON.parse(data.query);
              data.query = "";

              for(let key in query) {

                  let filter = query[key];

                  if(filter.isActive) {

                    if(filter.type == 'category') {
                      data[filter.queryName] = filter.options;
                    }
                    if(filter.type == 'brand') {
                      data[filter.queryName] = filter.options;
                    }

                    else if(filter.type == 'search') {
                      data.query = filter.value;
                    }

                    else if (filter.type == 'date') {
                      data[filter.queryName] = {
                        start: filter.options.date1 == "" ? null : filter.options.date1,
                        end: filter.options.date2 == "" ? null : filter.options.date2
                      }
                    }

                    else if (filter.type == 'dropdown') {
                      data[filter.queryName] = filter.options.id;
                    }

                    else {
                      let selected = filter.options.filter(option => option.selected == true)[0];
                      if(typeof selected != 'undefined') {
                          if(filter.queryName == 'multiple') {
                              data[selected.queryName] = selected.id;
                          } else {
                              data[filter.queryName] = selected.id;
                          }
                      }
                    }
                  }
                }

            }

            // if there was a pharamcy selected ,...
            if(self.pharmacySelected != null) {
                data['site'] = self.pharmacySelected.id;
            }

            return this.axios.post(this.$config.api + 'pimProduct/query', data )
                .then(response => {
                    return response.data;
                }).catch(function (e) {
                    console.log("error ... :", e.message);
                }.bind(this))

          },

          uniqueKey: 'id',
          perPage: 50,
          /*
          orderBy: {
              ascending: false,
              column: 'updated_at'
          },
          */
          sortIcon: {
              base:'fa',
              up:'fa-sort-up',
              down:'fa-sort-down',
              is:'fa-sort'
          },
          saveState: true,
          preserveState: true,
          filterable: true,
          headings: {

              extRef(h) {
                  return <lang labelKey="PIM-TABLE_HEADING-EXTREF"></lang>
              },
              name(h) {
                  return <lang labelKey="PIM-TABLE_HEADING-NAME"></lang>
              },
              image(h) {
                  return <lang labelKey="PIM-TABLE_HEADING-IMAGE"></lang>
              },
              categoryPath(h) {
                  return <lang labelKey="PIM-TABLE_HEADING-CATEGORY_PAT"></lang>
              },
              price(h) {
                  return <lang labelKey="PIM-TABLE_HEADING-PRICE"></lang>
              },
              packagingSize(h) {
                  return <lang labelKey="PIM-TABLE_HEADING-PACKAGING_SIZE"></lang>
              },
              manufacturerName(h) {
                  return <lang labelKey="PIM-TABLE_HEADING-MANUFACTURER"></lang>
              },
              group_id(h) {
                  return "";
              },
              actions(h) {
                  return "";
              },
          },
          sortable: ['extRef', 'name', 'categoryPath', 'price', 'packagingSize', 'manufacturerName'],
          texts: {
              first:'Anfang',
              last:'Ende',
              filter: 'Filter Ergebnisse:',
              filterPlaceholder: 'Suche',
              limit: 'Einträge pro Seite',
              noResults: 'keine passenden Einträge gefunden',
              count: '{from} bis {to} von {count} Einträgen|{count} Einträge|ein Eintrag',
              loading: 'Lade Daten ...'
          },
          pagination: {
              dropdown: false,
              chunk: 5,
              edge: false
          },

          initialPage: self.$store.getters.getCurrentPimTablePage || 1,
          skin: 'table is-striped is-hoverable is-fullwidth',

          columnsClasses: {
              'select': 'firstCol',
              'extRef': 'pzn',
              'name': 'name',
              'categoryPath': 'category',
              'packagingSize': 'packagingSize',
              'price': 'price',
              'image': 'thumbnail',
              'group_id': 'variable',
              'actions': 'actions'
          },

          rowClassCallback: function(row) {
            if(self.preselectedProducts.length == 0) {
                return;
            }
            return self.preselectedProducts.indexOf(parseInt(row.id)) != -1 ? 'is-disabled' : '';
          }

        }
      },
    }

  },

  computed: {

    filtersSelected() { 

      if(this.showFilters.length > 0) {
        let arr = {};
        this.showFilters.forEach(f => {
          if(this.filters[f]) {
              arr[f] = this.filters[f];
          }
        })
        return arr;
      }

      else if(this.showFilters.length === 0 || this.showFilters===false) {
        return [];
      }

      else {
        return this.filters;
      }
    },

    sortimentUploadTypes() {
      return ['default', 'ait2', 'apotronik']
    },

    tblColumns() {
      return ['select', 'image', 'extRef', 'name', 'categoryPath', 'price', 'packagingSize', 'manufacturerName', 'group_id', 'actions'];
    },

    isFilterActive() {
      for(let key in this.filters) {
          if(this.filters[key].isActive == true) {
              return true;
          }
      }
    },

    acceptedFilesTotal() {
        let i = 0;
        this.files.accepted.forEach(a => {
            a.assets.forEach(asset => {
                i++;
            })
        });
        return i;
    },

    acceptedFiles() {
      return this.files.accepted;
    },

    rejectedFiles() {
      return this.files.rejected;
    },

    apopointProductVisibility() {
      return this.$store.getters.getTermsByTaxonomy('APOPOINT_PRODUCT_VISIBILITY');
    },

    apointVisibility() {
		  return this.$store.getters.getTermsByTaxonomy('APOPOINT_VISIBILITY');
    },

    /*
    currentPimTablePage() {
        return this.$store.getters.getCurrentPimTablePage || 1;
    },
    */

    pharmacySelected() {
      return this.$store.getters.getPIMPharmacy;
    },

    pharmacySelectedWrapper: {

      get() {
        return this.pharmacySelected == null
            ? null
            : this.pharmacies.find(_ => _.id == this.pharmacySelected.id);
      },

      set(value) {
        this.$store.commit('setPIMPharmacy', value != null ? value : null)
      }

    },

  },

  watch: {

    "filters.filterSearch.value"(val) {
        this.filters.filterSearch.isActive = !(val == null || val == "");
    },

    pharmacySelected(pharmacy) {
      // if there was a pharmacy selected, make sure to add the "lokal verfügbar" filter
      let foundIndex = this.filters.filterStockType.options.findIndex((o) => o.id == "local");

      if(pharmacy != null && pharmacy.erp != null && foundIndex == -1) {

        this.filters.filterStockType.options.push({
          name: 'lokal verfügbar', 
          selected: false, 
          id: 'local',
        })
      
      // ... and make sure to remove this filter, if the pharmacy is de-selected
      } else if(foundIndex > -1) {
        this.filters.filterStockType.options.splice(foundIndex, 1);
      }

      this.filter();

    },

    markedRows(val) {

      this.$emit('selectedRows', this.markedRows)
    },

  },

  created() {

    this.markedRows = [];

    if(this.$route.params.pharmacy) {
      this.$store.commit('setPIMPharmacy', { id: this.$route.params.pharmacy });
    }

    if(this.userRole == 'Apotheke') {
      this.$store.commit('setPIMPharmacy', this.activeUser.site);
    } else if(this.showPharmacyFilter && this.userRole == 'Administrator') {
      this.fetchPharmacies();
    }

    if(this.pharmacySelected != null && this.pharmacySelected.id) {
      this.filters.filterCategory.api += '?site='+this.pharmacySelected.id;
    }

  },


  mounted() {

    // check for saved filters in store
    if(this.$store.getters.getPIMFilter != null) {
        this.filters = this.$store.getters.getPIMFilter;
    }

    Event.$on('vue-tables.pimTable.loading', () => {
        this.isLoadingTableData = true;
        this.$emit('dataLoaded', false);
    });

    Event.$on('vue-tables.pimTable.loaded', () => {
        this.isLoadingTableData = false;
        this.$emit('dataLoaded', true);
    });

    Event.$on('vue-tables.pimTable.pagination', (data) => {
        this.$store.commit('setCurrentPimTablePage', data);
    });

    Event.$on('vue-tables.pimTable.row-click', this.onRowClickHandler);

  },

  beforeDestroy() {
    Event.$off('vue-tables.pimTable.row-click', this.onRowClickHandler);
  },

  methods: {

    onRowClickHandler(data) {
      if(['checkboxWrapper', 'checkbox', 'firstCol', 'actions', 'button', 'icon'].indexOf(data.event.target.className) > -1
          || ['p-default p-curve p-smooth pretty'].indexOf(data.event.target.parentElement.className) > -1) {
          return false;
      }

      // if it is allowed to edit a product -> redirect to product detail page
      if(this.allowEditProduct) {

          this.$router.push({ name: 'pimProduct', params: { id: data.row.id }}).catch(err => {});

      // otherwise imitate checkbox click (select/deselect product)
      } else {

          if (this.preselectedProducts.indexOf(parseInt(data.row.id)) !== -1) {
              return false;
          }

          let foundIndex = this.markedRows.findIndex(r => r == data.row);

          if(foundIndex > -1) {
              this.markedRows.splice(foundIndex, 1);
          } else {

            if(this.singleSelectOnly && this.markedRows.length > 0) {
                this.markedRows = [data.row];
            } else {
                this.markedRows.push(data.row);
            }
          }

      }
    },

    deleteProduct(product) {
      // make confirmation before that ...
      this.axios.delete(this.$config.api + 'pimProduct/'+product.id).then(res => {

        this.$refs.pimTable.refresh();

        // refresh server table after deletion
        this.$notify.open({ content: "Produkt wurde erfolgreich entfernt", type: "success"});

      })
    },

    newProduct() {
      this.$router.push({ name: 'pimProductNew' })
    },

    resetFilters() {

      for(let key in this.filters) {

          if(this.filters[key].type != 'search') {
              this.filters[key].isActive = false;
          } else {
              this.filters.filterSearch.value = null;
          }

      }

      this.filter();

    },

    /*
		getImagePath(asset, thumb=false) {
			return this.$config.assets + asset.path + '/' + (thumb != false ? 'thumb/' : '') + asset.filename;
		},
    */

    toggleMarkAll() {

      // this.markedRows = this.allMarked ? [] : this.$refs.pimTable.tableData.map(row => row.id);
      this.markedRows = this.allMarked ? [] : this.$refs.pimTable.tableData.filter(row => this.preselectedProducts.indexOf(parseInt(row.id)) === -1);
      this.allMarked = !this.allMarked;

    },

    changeName(id, e) {

      if(id == "" || e.target.value == "") {
	        return;
      }

      var self = this;
      this.axios.put(this.$config.api + 'pimProduct/'+id, { name: e.target.value })
          .then(res => self.$notify.success( {content: 'Erfolgreich gespeichert!' }) );

    },

    /*
    loadCategories() {

        var self = this;
        console.log("pharmacySelected: ", this.pharamcySelected);

        return new Promise(function(resolve, reject) {

            let url = self.$config.api + 'pimCategory/tree' + (self.pharmacySelected != null && self.pharmacySelected.id ? '?site='+self.pharmacySelected.id : '');
            // let url = self.$config.api + 'pimCategory/tree';

            self.axios.get(url)
                .then(res => {
                    resolve(res);
                })

        });

    },
    */

    fetchPharmacies() {

      this.axios.get(this.$config.api + 'site?filters[hasCustomAssortment]=1&orderBy=name').then(res => {

        this.pharmacies = res.data.site;

        this.pharmacies.forEach((p) => {
          p._name = p.name;
          if(this.userRole == 'Administrator') {
            p._name += ' (#' + p.extRef + ')';
          }
        })

        this.pharmaciesLoaded = true;
      })

    },

    filter() {
      // debugger;
      let query = "";

      this.$store.commit('setPIMFilter', this.filters)
      this.$refs.pimTable.setFilter(JSON.stringify(this.filters));
    },


  }

}
</script>


<style lang="scss" scoped>

  @import '~../../assets/css/variables.scss';
  @import '~pretty-checkbox/src/pretty-checkbox.scss';

  .p-default {
      margin: 0;
  }

  .filterBox {
    border: none;
    border-top: 1px solid #eaeaea;
    transition: all .3s ease;
    padding: 0;
    margin-bottom: 15px;

    legend {
      margin-left: 20px;
      text-transform: uppercase;
      padding: 0 5px;
      font-size: 13px;
      cursor: pointer;
    }

    .filterWrapper {
      display: flex;
      flex-wrap: wrap;
      justify-content: flex-start;
      align-items: flex-start;
      margin: 0 0 10px 0;
    }

    &.active {
      border: 1px solid #eaeaea;
      border-radius: 4px;
      background: #FFF;

      > .filterWrapper {
          margin: 6px 10px;
      }
    }

  }

  ::v-deep .VueTables__table {

    .thumbnail {
      .imgWrapper {
        position: relative;
        background-repeat: no-repeat;
        background-position: 50% 50%;
        background-size: contain;
        width: 80px;
        height: 65px;
        margin: 0;
        background-color: #FFF;
        border: 1px solid #efefef;
        border-radius: 2px;

        &[lazy=loading]  {
          background-size: 30% !important;
        }
        &[lazy=error]  {
          background-image: none !important;
        }
        
        .status {
          position: absolute;
          z-index: 99;
          right: 2px;
          top: 2px;
          border-radius: 25%;
          background: transparent;
          width: 11px;
          height: 11px;
          border: 1px solid #aaa;

          &.available {
            background-color: #008000;
            border: none;
          }
          &.currently-not-available {
            background-color: #664949;
            border: none;
          }
          &.not-available {
            background-color: #8e8e8e;
            border: none;
          }
          &.local {
            background-color: #70ea3c;
            border: none;
          }

        }
      }
    }
    
    .price,
    .packagingSize
    {
      text-align: right;
    }
    .category {
      white-space: normal !important;
    }
    td {
      vertical-align: middle !important;
    }
    td.actions {
      text-align: right;
      .button {
        .icon {
            margin: 0 !important;
            font-size: 12px;
        }
      }
    }
  }

  .pharmacySelector {

    padding: 15px;
    display: flex;
    flex-direction: column;

    .pharmacySelectorLabel {
      font-size: 10px;
      text-transform: uppercase;
      padding-bottom: 4px;
    }

    > div {
      margin: 0;
      width: 100%;
      ::v-deep .control {
          margin-bottom: 0;
          max-width: 100% !important;
      }

      &:not(:last-child) {
          margin-right: 5px;
      }
    }

    .button {
      font-size: 11px;
      text-transform: uppercase;
      line-height: inherit;
      display: flex;
      align-items: center;
      justify-content: center;
    }

  }

</style>

<style scoped>

  >>> .checkboxWrapper {
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    padding-left: 4px;
  }

  .inputName {
    margin: 0;
    padding: 0;
    height: auto;
    line-height: inherit;
    font-size: 12px;
    background: none;
    border: 0;
    transition: all .3s ease;
    cursor: pointer;
  }

  .inputName:not(:focus) {
    white-space: nowrap;
  	overflow: hidden;
  	text-overflow: ellipsis;
  }

  .inputName:focus {
    padding: 8px;
    background: #eaeaea;
  }

  >>> .pimTable .VueTables__search {
    display: none;
  }
  >>> .pimTable .VueTables__table {
    position: relative !important;
  }
  >>> .pimTable .VueTables__table tr.is-disabled {
    opacity: 0.3;
  }
  >>> .pimTable .VueTables__table td {
    position: relative !important;
  }

  .overlay-loader {
    position: absolute;
    z-index: 1;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: white;
    opacity: 0.8;
  }

  >>> .pimTable .v-spinner {
    position: absolute !important;
    z-index: 999;
    top: 0 !important;
    bottom: 0;
    height: 100% !important;
    width: 100vw;
  }

  >>> .pimTable .VueTables__table td:first-child {
    width: 20px;
    max-width: 20px;
  }
  >>> .pimTable .VueTables__table td.thumbnail {
    width: 100px;
    max-width: 100px;
  }
  >>> .pimTable .VueTables__table td.pzn {
    width: 100px;
    max-width: 100px;
  }
  >>> .pimTable .VueTables__table td.packagingSize {
    width: 120px;
    max-width: 120px;
  }
  >>> .pimTable .VueTables__table td.price {
    width: 100px;
    max-width: 100px;
  }
  >>> .pimTable .VueTables__table td.variable,
  >>> .pimTable .VueTables__table th.variable {
    width: 50px;
    max-width: 50px;
    text-align: center;
  }
  >>> .pimTable .VueTables__table td.actions,
  >>> .pimTable .VueTables__table th.actions {
    width: 80px;
    max-width: 80px;
    text-align: center;
  }


  .loadingOverlay {
    position: absolute;
    z-index: 99;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: #FFF;
    background: rgba(255,255,255,.5);
    display: flex;
    justify-content: center;
    align-items: center;
  }


  >>> .v-spinner.small {
		height: auto !important;
		max-width: 250px;
        margin: 0;
	}
	>>> .v-spinner.small .v-clip {
		height: 12px !important;
		width: 12px !important;
	}

  >>> .customWarning {
    font-size: 12px;
    padding-top: 0;
    padding-bottom: 0;
    background-color: transparent !important;
    color: #666 !important;
  }
  >>> .customWarning .wrap-icon {
    margin-top: -9px;
  }
  >>> .customWarning .wrap-icon i {
    font-size: 16px;
    color: #666;
  }
</style>
